import { api } from "shared/config/api/api";

import { fetchAllPages } from "./fetchAllPages";
import { PROMO_URL } from "./promoUrl";

import type {
  PromosPage,
  RafflesBoard,
  RecentPage,
  RecentRaffle,
} from "../model/types";

export const raffleListApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Все текущие (до розыгрыша) открытые и приватные, с прогрессом зрителя.
    getRafflesBoard: builder.query<RafflesBoard, void>({
      queryFn: async (_arg, _api, _extra, fetchPage) => {
        const result = await fetchAllPages<PromosPage>(fetchPage, {
          url: `${PROMO_URL}/wheel-raffles/promos`,
          params: { scope: "current" },
        });
        if ("error" in result) return result;
        return {
          data: {
            items: result.data.flatMap((page) => page.items),
            viewerTier: result.data[0]?.viewer_deposit_tier ?? null,
          },
        };
      },
      providesTags: ["WheelRaffle"],
    }),
    // Текущие + разыгранные за последние `days` дней.
    getRafflesHistory: builder.query<RecentRaffle[], number>({
      queryFn: async (days, _api, _extra, fetchPage) => {
        const result = await fetchAllPages<RecentPage>(fetchPage, {
          url: `${PROMO_URL}/wheel-raffles/recent`,
          params: { days },
        });
        if ("error" in result) return result;
        return { data: result.data.flatMap((page) => page.items) };
      },
      providesTags: ["WheelRaffle"],
    }),
  }),
});

export const { useGetRafflesBoardQuery, useGetRafflesHistoryQuery } =
  raffleListApi;
